// extracted by mini-css-extract-plugin
export default {"home":"c-i_cJ","home__background":"c-i_cK","home__content":"c-i_cL"};